// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BfuFy{padding:0 16px}.G5pg2{height:238px;border-radius:8px;padding:0 16px;overflow:hidden}.NpqTn{padding-bottom:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BfuFy`,
	"responsivePlayer": `G5pg2`,
	"scrollableList": `NpqTn`
};
export default ___CSS_LOADER_EXPORT___;
